import axios, { buildApi } from '@/libs/api.request';
import { getToken } from "@/libs/util";

let name = '/work/category'

export const apis = buildApi({
  get: [name + '/index&list',],
  post: [name + '/save', name + '/delete/:id&del']
})

export const upload = data => {
  return axios.request({
    url: "/work/category/upload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};